<template>
    <article>
        <language-changer></language-changer>
        <!-- demonstration only - we shouldn't scale SVG icons to this size -->
        <svg id="logo" class="mds-icon">
            <use xlink:href="static/mds/icons/mds_icons.svg#morningstar-logo">
                <title>Morningstar</title>
            </use>
        </svg>
        <loading-spinner v-if="msg === null" :size="2"></loading-spinner>
        <!-- while Vue does support an "else" attribute, it requires placing
             the elements directly adjacent, in the correct order. this will
             make it difficult to move elements around while preserving the
             conditional rendering logic - best if each element can operate
             independently of any others. -->
        <h1 v-if="msg">{{$t(msg)}}</h1>
        <!-- list container wrapper for spacing -->
        <section class="hello mds-doc-space__inset-stack-container">
            <!-- list group wrapper -->
            <ul class="mds-list-group">
                <!-- list group heading -->
                <li class="mds-list-group__item mds-list-group__item--header">{{$t("Essential Links")}}</li>
                <!-- list group items -->
                <template v-for="(item) in links">
                    <li class="mds-list-group__item">
                        <!-- link class wraps item label -->
                        <a class="mds-list-group__link" :href="item[1]" target="_blank">
                            <!-- item label styled as a span -->
                            <span class="mds-list-group__item-label">{{$t(item[0])}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </section>
        <section class="hello mds-doc-space__inset-stack-container">
            <ul class="mds-list-group">
                <li class="mds-list-group__item mds-list-group__item--header">{{$t("Ecosystem")}}</li>
                <template v-for="(item) in resources">
                    <li class="mds-list-group__item">
                        <a class="mds-list-group__link" :href="item[1]" target="_blank">
                            <span class="mds-list-group__item-label">{{$t(item[0])}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </section>
    </article>
</template>

<style lang="scss">
    #logo {
        fill: $mds-color-red-50;
        width: 100%;
        height: auto;
    }
    .mds-loader {
        width: 100%;
    }
</style>

<script>

    import {mapState} from "vuex";
    import {importComponents} from "@/utils";
    import data from "@/assets/Hello.json";

    export default {
        name: "hello",
        computed: mapState("demo", ["msg"]),
        components: importComponents([
            "LanguageChanger",
            "LoadingSpinner"
        ]),
        data () {
            return data;
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Hello.vue